var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirefox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 81.96698,
    width: 87.418564,
    id: "svg1008",
    viewBox: "0 0 87.418564 81.96698",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs978"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(3.7,-0.0040855)",
    gradientUnits: "userSpaceOnUse",
    y2: 74.468002,
    x2: 6.447,
    y1: 12.393,
    x1: 70.786003,
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop834",
    stopColor: "#fff44f",
    offset: 0.048
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop836",
    stopColor: "#ffe847",
    offset: 0.111
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop838",
    stopColor: "#ffc830",
    offset: 0.225
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop840",
    stopColor: "#ff980e",
    offset: 0.368
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop842",
    stopColor: "#ff8b16",
    offset: 0.401
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop844",
    stopColor: "#ff672a",
    offset: 0.462
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop846",
    stopColor: "#ff3647",
    offset: 0.534
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop848",
    stopColor: "#e31587",
    offset: 0.705
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7978.7,8523.9959)",
    r: 80.796997,
    cy: -8515.1211,
    cx: -7907.187,
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop851",
    stopColor: "#ffbd4f",
    offset: 0.129
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop853",
    stopColor: "#ffac31",
    offset: 0.186
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop855",
    stopColor: "#ff9d17",
    offset: 0.247
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop857",
    stopColor: "#ff980e",
    offset: 0.283
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop859",
    stopColor: "#ff563b",
    offset: 0.403
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop861",
    stopColor: "#ff3750",
    offset: 0.467
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop863",
    stopColor: "#f5156c",
    offset: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop865",
    stopColor: "#eb0878",
    offset: 0.782
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop867",
    stopColor: "#e50080",
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7978.7,8523.9959)",
    r: 80.796997,
    cy: -8482.0889,
    cx: -7936.7109,
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop870",
    stopColor: "#960e18",
    offset: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop872",
    stopOpacity: 0.74,
    stopColor: "#b11927",
    offset: 0.351
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop874",
    stopOpacity: 0.343,
    stopColor: "#db293d",
    offset: 0.435
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop876",
    stopOpacity: 0.094,
    stopColor: "#f5334b",
    offset: 0.497
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop878",
    stopOpacity: 0,
    stopColor: "#ff3750",
    offset: 0.53
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7978.7,8523.9959)",
    r: 58.534,
    cy: -8533.457,
    cx: -7926.9702,
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop881",
    stopColor: "#fff44f",
    offset: 0.132
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop883",
    stopColor: "#ffdc3e",
    offset: 0.252
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop885",
    stopColor: "#ff9d12",
    offset: 0.506
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop887",
    stopColor: "#ff980e",
    offset: 0.526
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7978.7,8523.9959)",
    r: 38.471001,
    cy: -8460.9844,
    cx: -7945.6479,
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop890",
    stopColor: "#3a8ee6",
    offset: 0.353
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop892",
    stopColor: "#5c79f0",
    offset: 0.472
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop894",
    stopColor: "#9059ff",
    offset: 0.669
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop896",
    stopColor: "#c139e6",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.972,-0.235,0.275,1.138,10095.002,7833.7939)",
    r: 20.396999,
    cy: -8491.5459,
    cx: -7935.6201,
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop899",
    stopOpacity: 0,
    stopColor: "#9059ff",
    offset: 0.206
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop901",
    stopOpacity: 0.064,
    stopColor: "#8c4ff3",
    offset: 0.278
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop903",
    stopOpacity: 0.45,
    stopColor: "#7716a8",
    offset: 0.747
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop905",
    stopOpacity: 0.6,
    stopColor: "#6e008b",
    offset: 0.975
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7978.7,8523.9959)",
    r: 27.676001,
    cy: -8518.4268,
    cx: -7937.731,
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop908",
    stopColor: "#ffe226",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop910",
    stopColor: "#ffdb27",
    offset: 0.121
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop912",
    stopColor: "#ffc82a",
    offset: 0.295
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop914",
    stopColor: "#ffa930",
    offset: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop916",
    stopColor: "#ff7e37",
    offset: 0.732
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop918",
    stopColor: "#ff7139",
    offset: 0.792
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7978.7,8523.9959)",
    r: 118.081,
    cy: -8535.9814,
    cx: -7915.9771,
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop921",
    stopColor: "#fff44f",
    offset: 0.113
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop923",
    stopColor: "#ff980e",
    offset: 0.456
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop925",
    stopColor: "#ff5634",
    offset: 0.622
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop927",
    stopColor: "#ff3647",
    offset: 0.716
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop929",
    stopColor: "#e31587",
    offset: 0.904
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.105,0.995,-0.653,0.069,-4680.304,8470.1869)",
    r: 86.499001,
    cy: -8522.8594,
    cx: -7927.165,
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop932",
    stopColor: "#fff44f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop934",
    stopColor: "#ffe847",
    offset: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop936",
    stopColor: "#ffc830",
    offset: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop938",
    stopColor: "#ff980e",
    offset: 0.304
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop940",
    stopColor: "#ff8b16",
    offset: 0.356
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop942",
    stopColor: "#ff672a",
    offset: 0.455
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop944",
    stopColor: "#ff3647",
    offset: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop946",
    stopColor: "#e31587",
    offset: 0.737
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7978.7,8523.9959)",
    r: 73.720001,
    cy: -8508.1758,
    cx: -7938.3828,
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop949",
    stopColor: "#fff44f",
    offset: 0.137
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop951",
    stopColor: "#ff980e",
    offset: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop953",
    stopColor: "#ff5634",
    offset: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop955",
    stopColor: "#ff3647",
    offset: 0.655
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop957",
    stopColor: "#e31587",
    offset: 0.904
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7978.7,8523.9959)",
    r: 80.685997,
    cy: -8503.8613,
    cx: -7918.9229,
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop960",
    stopColor: "#fff44f",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop962",
    stopColor: "#ffe141",
    offset: 0.231
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop964",
    stopColor: "#ffaf1e",
    offset: 0.509
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop966",
    stopColor: "#ff980e",
    offset: 0.626
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(3.7,-0.0040855)",
    gradientUnits: "userSpaceOnUse",
    y2: 66.806,
    x2: 15.267,
    y1: 12.061,
    x1: 70.013,
    id: "l"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop969",
    stopOpacity: 0.8,
    stopColor: "#fff44f",
    offset: 0.167
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop971",
    stopOpacity: 0.634,
    stopColor: "#fff44f",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop973",
    stopOpacity: 0.217,
    stopColor: "#fff44f",
    offset: 0.489
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop975",
    stopOpacity: 0,
    stopColor: "#fff44f",
    offset: 0.6
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#a)"
    },
    id: "path980",
    d: "m 79.616,26.826915 c -1.684,-4.052 -5.1,-8.427 -7.775,-9.81 a 40.266,40.266 0 0 1 3.925,11.764 l 0.007,0.065 c -4.382,-10.925 -11.813,-15.33 -17.882,-24.9220005 -0.307,-0.485 -0.614,-0.971 -0.913,-1.484 -0.171,-0.293 -0.308,-0.557 -0.427,-0.8 a 7.053,7.053 0 0 1 -0.578,-1.535 0.1,0.1 0 0 0 -0.088,-0.1 0.138,0.138 0 0 0 -0.073,0 c -0.005,0 -0.013,0.009 -0.019,0.011 -0.006,0.002 -0.019,0.011 -0.028,0.015 l 0.015,-0.026 c -9.735,5.7 -13.038,16.2520005 -13.342,21.5300005 a 19.387,19.387 0 0 0 -10.666,4.111 11.587,11.587 0 0 0 -1,-0.758 17.968,17.968 0 0 1 -0.109,-9.473 28.705,28.705 0 0 0 -9.329,7.21 h -0.018 c -1.536,-1.947 -1.428,-8.367 -1.34,-9.708 a 6.928,6.928 0 0 0 -1.294,0.687 28.225,28.225 0 0 0 -3.788,3.245 33.845,33.845 0 0 0 -3.623,4.347 v 0.006 -0.007 a 32.733,32.733 0 0 0 -5.2,11.743 l -0.052,0.256 c -0.073,0.341 -0.336,2.049 -0.381,2.42 0,0.029 -0.006,0.056 -0.009,0.085 A 36.937,36.937 0 0 0 5,41.041915 v 0.2 a 38.759,38.759 0 0 0 76.954,6.554 c 0.065,-0.5 0.118,-0.995 0.176,-1.5 a 39.857,39.857 0 0 0 -2.514,-19.469 z m -44.67,30.338 c 0.181,0.087 0.351,0.181 0.537,0.264 l 0.027,0.017 q -0.282,-0.135 -0.564,-0.281 z m 8.878,-23.376 z m 31.952,-4.934 v -0.037 l 0.007,0.041 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#b)"
    },
    id: "path982",
    d: "m 79.616,26.826915 c -1.684,-4.052 -5.1,-8.427 -7.775,-9.81 a 40.266,40.266 0 0 1 3.925,11.764 v 0.037 l 0.007,0.041 a 35.1,35.1 0 0 1 -1.206,26.158 c -4.442,9.531 -15.194,19.3 -32.024,18.825 -18.185,-0.515 -34.2,-14.009 -37.194,-31.683 -0.545,-2.787 0,-4.2 0.274,-6.465 A 28.876,28.876 0 0 0 5,41.041915 v 0.2 a 38.759,38.759 0 0 0 76.954,6.554 c 0.065,-0.5 0.118,-0.995 0.176,-1.5 a 39.857,39.857 0 0 0 -2.514,-19.469 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#c)"
    },
    id: "path984",
    d: "m 79.616,26.826915 c -1.684,-4.052 -5.1,-8.427 -7.775,-9.81 a 40.266,40.266 0 0 1 3.925,11.764 v 0.037 l 0.007,0.041 a 35.1,35.1 0 0 1 -1.206,26.158 c -4.442,9.531 -15.194,19.3 -32.024,18.825 -18.185,-0.515 -34.2,-14.009 -37.194,-31.683 -0.545,-2.787 0,-4.2 0.274,-6.465 A 28.876,28.876 0 0 0 5,41.041915 v 0.2 a 38.759,38.759 0 0 0 76.954,6.554 c 0.065,-0.5 0.118,-0.995 0.176,-1.5 a 39.857,39.857 0 0 0 -2.514,-19.469 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#d)"
    },
    id: "path986",
    d: "m 60.782,31.382915 c 0.084,0.059 0.162,0.118 0.241,0.177 a 21.1,21.1 0 0 0 -3.6,-4.695 C 45.377,14.816915 54.266,0.7419145 55.765,0.0269145 l 0.015,-0.022 c -9.735,5.7 -13.038,16.2520005 -13.342,21.5300005 0.452,-0.031 0.9,-0.069 1.362,-0.069 a 19.56,19.56 0 0 1 16.982,9.917 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#e)"
    },
    id: "path988",
    d: "m 43.825,33.788915 c -0.064,0.964 -3.47,4.289 -4.661,4.289 -11.021,0 -12.81,6.667 -12.81,6.667 0.488,5.614 4.4,10.238 9.129,12.684 0.216,0.112 0.435,0.213 0.654,0.312 q 0.569,0.252 1.138,0.466 a 17.235,17.235 0 0 0 5.043,0.973 c 19.317,0.906 23.059,-23.1 9.119,-30.066 a 13.38,13.38 0 0 1 9.345,2.269 19.56,19.56 0 0 0 -16.982,-9.917 c -0.46,0 -0.91,0.038 -1.362,0.069 a 19.387,19.387 0 0 0 -10.666,4.111 c 0.591,0.5 1.258,1.168 2.663,2.553 2.63,2.591 9.375,5.275 9.39,5.59 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#f)"
    },
    id: "path990",
    d: "m 43.825,33.788915 c -0.064,0.964 -3.47,4.289 -4.661,4.289 -11.021,0 -12.81,6.667 -12.81,6.667 0.488,5.614 4.4,10.238 9.129,12.684 0.216,0.112 0.435,0.213 0.654,0.312 q 0.569,0.252 1.138,0.466 a 17.235,17.235 0 0 0 5.043,0.973 c 19.317,0.906 23.059,-23.1 9.119,-30.066 a 13.38,13.38 0 0 1 9.345,2.269 19.56,19.56 0 0 0 -16.982,-9.917 c -0.46,0 -0.91,0.038 -1.362,0.069 a 19.387,19.387 0 0 0 -10.666,4.111 c 0.591,0.5 1.258,1.168 2.663,2.553 2.63,2.591 9.375,5.275 9.39,5.59 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#g)"
    },
    id: "path992",
    d: "m 29.965,24.356915 c 0.314,0.2 0.573,0.374 0.8,0.531 a 17.968,17.968 0 0 1 -0.109,-9.473 28.705,28.705 0 0 0 -9.329,7.21 c 0.189,-0.005 5.811,-0.106 8.638,1.732 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#h)"
    },
    id: "path994",
    d: "m 5.354,42.158915 c 2.991,17.674 19.009,31.168 37.194,31.683 16.83,0.476 27.582,-9.294 32.024,-18.825 a 35.1,35.1 0 0 0 1.206,-26.158 v -0.037 c 0,-0.029 -0.006,-0.046 0,-0.037 l 0.007,0.065 c 1.375,8.977 -3.191,17.674 -10.329,23.555 l -0.022,0.05 c -13.908,11.327 -27.218,6.834 -29.912,5 q -0.282,-0.135 -0.564,-0.281 c -8.109,-3.876 -11.459,-11.264 -10.741,-17.6 a 9.953,9.953 0 0 1 -9.181,-5.775 14.618,14.618 0 0 1 14.249,-0.572 19.3,19.3 0 0 0 14.552,0.572 c -0.015,-0.315 -6.76,-3 -9.39,-5.59 -1.405,-1.385 -2.072,-2.052 -2.663,-2.553 a 11.587,11.587 0 0 0 -1,-0.758 c -0.23,-0.157 -0.489,-0.327 -0.8,-0.531 -2.827,-1.838 -8.449,-1.737 -8.635,-1.732 h -0.018 c -1.536,-1.947 -1.428,-8.367 -1.34,-9.708 a 6.928,6.928 0 0 0 -1.294,0.687 28.225,28.225 0 0 0 -3.788,3.245 33.845,33.845 0 0 0 -3.638,4.337 v 0.006 -0.007 a 32.733,32.733 0 0 0 -5.2,11.743 c -0.019,0.079 -1.396,6.099 -0.717,9.221 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#i)"
    },
    id: "path996",
    d: "m 57.425,26.864915 a 21.1,21.1 0 0 1 3.6,4.7 c 0.213,0.161 0.412,0.321 0.581,0.476 8.787,8.1 4.183,19.55 3.84,20.365 7.138,-5.881 11.7,-14.578 10.329,-23.555 -4.384,-10.93 -11.815,-15.335 -17.884,-24.9270005 -0.307,-0.485 -0.614,-0.971 -0.913,-1.484 -0.171,-0.293 -0.308,-0.557 -0.427,-0.8 a 7.053,7.053 0 0 1 -0.578,-1.535 0.1,0.1 0 0 0 -0.088,-0.1 0.138,0.138 0 0 0 -0.073,0 c -0.005,0 -0.013,0.009 -0.019,0.011 -0.006,0.002 -0.019,0.011 -0.028,0.015 -1.499,0.711 -10.388,14.7860005 1.66,26.8340005 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#j)"
    },
    id: "path998",
    d: "m 61.6,32.035915 c -0.169,-0.155 -0.368,-0.315 -0.581,-0.476 -0.079,-0.059 -0.157,-0.118 -0.241,-0.177 a 13.38,13.38 0 0 0 -9.345,-2.269 c 13.94,6.97 10.2,30.972 -9.119,30.066 a 17.235,17.235 0 0 1 -5.043,-0.973 q -0.569,-0.213 -1.138,-0.466 c -0.219,-0.1 -0.438,-0.2 -0.654,-0.312 l 0.027,0.017 c 2.694,1.839 16,6.332 29.912,-5 l 0.022,-0.05 c 0.347,-0.81 4.951,-12.263 -3.84,-20.36 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#k)"
    },
    id: "path1000",
    d: "m 26.354,44.744915 c 0,0 1.789,-6.667 12.81,-6.667 1.191,0 4.6,-3.325 4.661,-4.289 a 19.3,19.3 0 0 1 -14.552,-0.572 14.618,14.618 0 0 0 -14.249,0.572 9.953,9.953 0 0 0 9.181,5.775 c -0.718,6.337 2.632,13.725 10.741,17.6 0.181,0.087 0.351,0.181 0.537,0.264 -4.733,-2.445 -8.641,-7.069 -9.129,-12.683 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#l)"
    },
    id: "path1002",
    d: "m 79.616,26.826915 c -1.684,-4.052 -5.1,-8.427 -7.775,-9.81 a 40.266,40.266 0 0 1 3.925,11.764 l 0.007,0.065 c -4.382,-10.925 -11.813,-15.33 -17.882,-24.9220005 -0.307,-0.485 -0.614,-0.971 -0.913,-1.484 -0.171,-0.293 -0.308,-0.557 -0.427,-0.8 a 7.053,7.053 0 0 1 -0.578,-1.535 0.1,0.1 0 0 0 -0.088,-0.1 0.138,0.138 0 0 0 -0.073,0 c -0.005,0 -0.013,0.009 -0.019,0.011 -0.006,0.002 -0.019,0.011 -0.028,0.015 l 0.015,-0.026 c -9.735,5.7 -13.038,16.2520005 -13.342,21.5300005 0.452,-0.031 0.9,-0.069 1.362,-0.069 a 19.56,19.56 0 0 1 16.982,9.917 13.38,13.38 0 0 0 -9.345,-2.269 c 13.94,6.97 10.2,30.972 -9.119,30.066 a 17.235,17.235 0 0 1 -5.043,-0.973 q -0.569,-0.213 -1.138,-0.466 c -0.219,-0.1 -0.438,-0.2 -0.654,-0.312 l 0.027,0.017 q -0.282,-0.135 -0.564,-0.281 c 0.181,0.087 0.351,0.181 0.537,0.264 -4.733,-2.446 -8.641,-7.07 -9.129,-12.684 0,0 1.789,-6.667 12.81,-6.667 1.191,0 4.6,-3.325 4.661,-4.289 -0.015,-0.315 -6.76,-3 -9.39,-5.59 -1.405,-1.385 -2.072,-2.052 -2.663,-2.553 a 11.587,11.587 0 0 0 -1,-0.758 17.968,17.968 0 0 1 -0.109,-9.473 28.705,28.705 0 0 0 -9.329,7.21 h -0.018 c -1.536,-1.947 -1.428,-8.367 -1.34,-9.708 a 6.928,6.928 0 0 0 -1.294,0.687 28.225,28.225 0 0 0 -3.788,3.245 33.845,33.845 0 0 0 -3.623,4.347 v 0.006 -0.007 a 32.733,32.733 0 0 0 -5.2,11.743 l -0.052,0.256 c -0.073,0.341 -0.4,2.073 -0.447,2.445 0,0.028 0,-0.029 0,0 A 45.094,45.094 0 0 0 5,41.041915 v 0.2 a 38.759,38.759 0 0 0 76.954,6.554 c 0.065,-0.5 0.118,-0.995 0.176,-1.5 a 39.857,39.857 0 0 0 -2.514,-19.469 z m -3.845,1.991 0.007,0.041 z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefox);
export default __webpack_public_path__ + "static/media/firefox.1618162e650a36d467337f441ad922fb.svg";
export { ForwardRef as ReactComponent };